export enum EExportFleetReportFormat {
  CSV = "CSV",
  XLSX = "XLSX",
  PDF = "PDF",
}
